import { render, staticRenderFns } from "./EditorChecklist.vue?vue&type=template&id=4ea6eb84"
import script from "./EditorChecklist.vue?vue&type=script&lang=js"
export * from "./EditorChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports